import { ComponentProps } from 'react'
import { styled } from '@portfolio/styles'
import { Close } from '@portfolio/icons'

const StyledCloseButton = styled('button', {
  position: 'absolute',
  top: '$40',
  right: '$40',
  width: 36,
  height: 36,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '$rMax',
  transition: '0.2s background',

  '&:hover': {
    background: '$gray500_02',
  },

  '&:active': {
    background: '$gray500_01',
  },

  '&:focus-visible': {
    outline: '$focusBlue solid 3px;',
  },
})

/**
 * Circular icon button that closes a modal. Positioned top-right of the modal
 * body. Shared by `ContactFormModal` and `KlaviyoFormModal`.
 */
export const CloseButton = ({
  'aria-label': ariaLabel = 'Close',
  ...props
}: ComponentProps<typeof StyledCloseButton>) => (
  <StyledCloseButton aria-label={ariaLabel} {...props}>
    <Close />
  </StyledCloseButton>
)
